import { useState, useEffect } from "react";
import Rating from "@mui/material/Rating";
import { styled } from "@mui/material/styles";
import StarFulled from "@/assets/icons/star-fulled.svg";
import StarEmpty from "@/assets/icons/hollowStarSmall.svg";
import EmptyStar from "@/assets/icons/emptyStar.svg";


const StyledRating = styled(Rating)({
  "&": {
    gap: "12px",
  },
});

export default function IntlRating({
  value: initValue,
  Highlight = false,
  onChange,
}: {
  onChange?: (value: number | null) => void;
  value: number | null;
  Highlight?: boolean
}) {
  const [value, setValue] = useState<number | null>(initValue || 0);

  useEffect(() => {
    setValue(initValue);
  }, [initValue]);

  return (
    <StyledRating
      value={value}
      sx={{
        "&": {
          fontSize: "20px",
        },
      }}
      onChange={(event, newValue: number | null) => {
        event.stopPropagation();
        setValue(newValue);
        onChange?.(newValue);
      }}
      icon={<StarFulled />}
      emptyIcon={ Highlight ? <EmptyStar /> : <StarEmpty /> }
    />
  );
}
